module.exports = __webpack_public_path__ + "img/places.7742b26c.png";